import { i18n } from '@libero/i18n/index';
import type { RouteRecordRaw } from 'vue-router';

import { generateContainerRoutes } from '../container/generate-routes';
import { generateTicketRoutes } from '../ticket/generate-routes';

export const routes: RouteRecordRaw[] = [
  {
    path: 'energy-connection',
    name: 'energy-connection.index',
    component: () => import('./views/pages/Index.vue'),
    children: [
      {
        path: ':id',
        component: () => import('./views/modals/Show.vue'),
        children: [
          {
            path: 'graph',
            name: 'energy-connection.graph',
            component: () => import('./views/tabs/Graph.vue'),
          },
          {
            path: 'properties',
            name: 'energy-connection.properties',
            component: () => import('./views/tabs/Properties.vue'),
          },
          {
            path: 'map',
            name: 'energy-connection.map',
            component: () => import('./views/tabs/Map.vue'),
          },
          {
            path: 'energy-contracts',
            name: 'energy-connection.energy-contracts',
            component: () => import('./views/tabs/EnergyContracts.vue'),
          },
          {
            path: 'log',
            name: 'energy-connection.log',
            component: () => import('./views/tabs/Log.vue'),
          },
          {
            path: '',
            name: 'energy-connection.show',
            redirect: { name: 'energy-connection.graph' },
          },
        ],
        meta: {
          delay: true,
          permission: 'energy-connection.show',
          theme: 'energy',
        },
      },
      ...generateContainerRoutes('energy-connection'),
      ...generateTicketRoutes('energy-connection'),
    ],
    meta: {
      title: i18n.global.t('energy-connection.energy'),
      permission: 'energy-connection.index',
      theme: 'energy',
    },
  },
];
